import * as React from 'react'

export const CheckIcon = React.memo<JSX.IntrinsicElements['svg']>((props) => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12 21C16.9706 21 21 16.9706 21 12C21 7.02944 16.9706 3 12 3C7.02944 3 3 7.02944 3 12C3 16.9706 7.02944 21 12 21ZM17.1353 9.04624C17.3872 8.71746 17.325 8.24669 16.9962 7.99473C16.6674 7.74278 16.1967 7.80505 15.9447 8.13382L10.6534 15.0382L8.06228 12.3768C7.77333 12.08 7.2985 12.0737 7.00171 12.3626C6.70493 12.6516 6.69858 13.1264 6.98753 13.4232L10.1757 16.6978C10.499 17.0298 11.0416 16.9977 11.3235 16.6299L17.1353 9.04624Z"
        fill="#003087"
      />
    </svg>
  )
})

CheckIcon.displayName = 'CheckIcon'
